<script setup lang="ts">
import type { TreatmentThumbFragment } from '#graphql-operations'

interface SearchTreatmentProps {
  data: TreatmentThumbFragment
}

defineProps<SearchTreatmentProps>()
</script>

<template>
  <Anchor :to="data.url" class="searchTreatment group">
    <Chip :label="data.title" class="motion-snug group-hover-media-mouse:bg-linen/60" />
  </Anchor>
</template>
